import { useQuery } from "@tanstack/react-query";
import { useState } from "react";

import { CreateMfaChallengeResponse } from "./types";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";
import { displayErrorToast } from "@/utils/toast";

export const useCreateMfaChallengeQuery = (
  onSuccess?: (data: CreateMfaChallengeResponse) => void,
) => {
  const auth = useAuth();
  const userToken = auth?.userToken ?? "";
  const [enabled, setEnabled] = useState(true);

  return useQuery({
    queryKey: ["mfa-challenge"],
    queryFn: (): Promise<CreateMfaChallengeResponse> =>
      fetch(ENDPOINTS.mfa.challenge, {
        method: "POST",
        headers: jsonAuthHeaders(userToken),
      }).then(handleResponse),
    enabled: enabled && !!userToken,
    retry: false,
    onSuccess: data => {
      setEnabled(false);
      if (onSuccess) {
        onSuccess(data);
      }
    },
    onError: (error: string) => {
      setEnabled(false);
      displayErrorToast(error);
    },
  });
};
